import type { WorldMeta } from "../registry";

export const meta: WorldMeta = {
  id: "FW-36",
  name: "Farline",
  slug: "farline",
  title: "Farline — a Fable World: travel launch page",
  description:
    "An original travel landing page designed by Fable: a 12-degree diagonal layout, choreographed flip-grid mosaics, teal and sand."
};

export default meta;
